import React from 'react'
import { useForm } from 'react-hook-form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Badge from 'react-bootstrap/Badge'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Select from 'react-select'
import { Controller } from 'react-hook-form'

import { QuestionFormPreviewPropsType } from '../../types'
import { CustomerContractFormType } from '@/components/features/CustomerContract/types'
import { isFieldTypeQuestion } from '@/components/features/ContractSetting/hooks/useContractSettingForm'

export const QuestionFormPreview: React.FC<QuestionFormPreviewPropsType> = (props) => {
  const {
    register,
    control,
    handleSubmit
  } = useForm<CustomerContractFormType>()
  const submitContract = handleSubmit((data: CustomerContractFormType) => {
    console.log(data)
  })

  return (
    <>
    <header className="row align-items-center justify-content-between">
      <Col className='h5 my-2 text-truncate'>{props.contractSettingName}</Col>
    </header>
    <Row>
      <Col>
        <Form onSubmit={submitContract}>
          <Row className='gy-3 mt-3'>
            {
              props.questionItems.filter(questionItem=>!isFieldTypeQuestion(questionItem.answerType)).map(questionItem => {
                switch (questionItem.answerType){
                  case 'date':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Form.Control
                          {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                          id={`answerItems.${questionItem.id}.value`}
                          type='date'
                          required={questionItem.isRequired}
                          className='mw-200px'
                        />
                      </Col>
                    )
                  case 'time':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Form.Control
                          {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                          id={`answerItems.${questionItem.id}.value`}
                          type='time'
                          required={questionItem.isRequired}
                          className='mw-200px'
                        />
                      </Col>
                    )
                  case 'textarea':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Form.Control
                          {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                          id={`answerItems.${questionItem.id}.value`}
                          as='textarea'
                          type='textarea'
                          required={questionItem.isRequired}
                        />
                      </Col>
                    )
                  case 'number':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <InputGroup className='mw-200px'>
                          <Form.Control
                            {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                            id={`answerItems.${questionItem.id}.value`}
                            type='number'
                            required={questionItem.isRequired}
                          />
                          <InputGroup.Text>{questionItem.unit}</InputGroup.Text>
                        </InputGroup>
                      </Col>
                    )
                  case 'single_select':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.selectedOptions`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Controller
                          control={control}
                          name={`answerItems.${questionItem.id}.selectedOption`}
                          render={({ field }) => (
                            <Select
                              options={questionItem.selectItemsText?.split(',').map(itemText=>({value: itemText, label: itemText}))}
                              {...field}
                            />
                          )}
                          rules={{required: questionItem.isRequired}}
                        />
                      </Col>
                    )
                  case 'multi_select':
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Row>
                          {
                            questionItem.selectItemsText?.split(',').map((itemText, i) =>
                              <Col className='text-nowrap' key={i}>
                                <Form.Check
                                  {...register(`answerItems.${questionItem.id}.checkedOptions.${i}.isChecked`)}
                                  inline
                                  type="checkbox"
                                  label={itemText}
                                />
                              </Col>
                            )
                          }
                        </Row>
                      </Col>
                    )
                  case 'name':
                  case 'name_kana':
                    return (
                      <React.Fragment key={questionItem.id}>
                        <Col xs={6}>
                          <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                            <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                          </Form.Label>
                          <Form.Control
                            {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                            id={`answerItems.${questionItem.id}.value`}
                            type='text'
                            required={questionItem.isRequired}
                          />
                        </Col>
                        <Col xs={6}>
                          <Form.Label htmlFor={`answerItems.${questionItem.id}.subvalue`}>
                            {questionItem.sublabel}
                          </Form.Label>
                          <Form.Control
                            {...register(`answerItems.${questionItem.id}.subvalue` as const, {required: questionItem.isRequired})}
                            id={`answerItems.${questionItem.id}.subvalue`}
                            type='text'
                            required={questionItem.isRequired}
                          />
                        </Col>
                      </React.Fragment>
                    )
                  default:
                    return (
                      <Col key={questionItem.id} xs={12}>
                        <Form.Label htmlFor={`answerItems.${questionItem.id}.value`}>
                          <span>{questionItem.label}</span> {questionItem.isRequired && <Badge bg='danger' className='align-text-bottom'>必須</Badge>}
                        </Form.Label>
                        <Form.Control
                          {...register(`answerItems.${questionItem.id}.value` as const, {required: questionItem.isRequired})}
                          id={`answerItems.${questionItem.id}.value`}
                          type='text'
                          required={questionItem.isRequired}
                        />
                      </Col>
                    )
                }
              })
            }
          </Row>
        </Form>
      </Col>
    </Row>
    </>
  )
}